var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47716 20 0 15.5228 0 10C0 4.47716 4.47716 0 10 0C15.5228 0 20 4.47716 20 10ZM10.9583 6.93166C9.2403 7.67372 4.28681 9.7811 4.28681 9.7811C3.11287 10.256 3.80002 10.7012 3.80002 10.7012C3.80002 10.7012 4.80217 11.0574 5.66119 11.3245C6.52016 11.5917 6.9783 11.2949 6.9783 11.2949C6.9783 11.2949 8.9826 9.92952 11.0155 8.4751C12.4472 7.46594 12.1036 8.29702 11.76 8.65322C11.0155 9.42494 9.78432 10.6419 8.75351 11.6214C8.29542 12.0369 8.52447 12.3931 8.7249 12.5712C9.30782 13.0825 10.6807 14.0124 11.3041 14.4346C11.4768 14.5516 11.592 14.6296 11.6168 14.6489C11.76 14.7677 12.5617 15.3019 13.0485 15.1832C13.5352 15.0645 13.5925 14.3818 13.5925 14.3818C13.5925 14.3818 13.9647 11.9479 14.3083 9.72174C14.372 9.28462 14.4356 8.85667 14.495 8.45763C14.6492 7.42057 14.7744 6.57875 14.7951 6.27866C14.881 5.2695 13.8502 5.68502 13.8502 5.68502C13.8502 5.68502 11.6168 6.63486 10.9583 6.93166Z",
    fill: "#34AADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorTg);
export default __webpack_public_path__ + "static/media/colorTG.36dc56856c4e539d7fd17a547c0da6c7.svg";
export { ForwardRef as ReactComponent };